import React, { useState } from "react";
import PropTypes from "prop-types";
import CommonModal from "./CommonModal";
import Modalstyle from "./modal.module.scss";
import { alertActions, pricingPlan } from "../../locales/en";

const PasswordSetModal = ({ isOpen, toggle, handlePasswordEntered }) => {
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setPassword(e.target.value);
    setErrors({});
  };

  const handleSave = () => {
    let isValid = true;
    const newErrors = { ...errors };

    if (password.trim() === "") {
      newErrors.password = [pricingPlan.bulkChange.table.passwordModal.errmsg];
      isValid = false;
    }

    setErrors(newErrors);

    if (isValid) {
      handlePasswordEntered(password);
      setPassword("");
      toggle(false);
    }
  };

  const handleClose = () => {
    setPassword("");
    setErrors({});
    toggle(false);
  };

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={handleClose}
      title={pricingPlan.bulkChange.table.passwordModal.title}
      modalClassName="modal-dialog-centered"
      bodyClassName={Modalstyle.commentModalWrap}
      footerButtons={[
        {
          label: alertActions?.Cancel,
          className: "btn btn-secondary",
          onClick: handleClose
        },
        {
          label: alertActions?.Confirm,
          className: "btn btn-primary",
          onClick: handleSave
        }
      ]}
    >
      <div className="row">
        <div className="mb-3 ">
          <div className={Modalstyle.modalInputwrap}>
            <label htmlFor="passwordInput" className="form-label">
              {pricingPlan.bulkChange.table.passwordModal.enterPass}
            </label>
            <div className={Modalstyle.formInput}>
              <input
                type="password"
                id="passwordInput"
                placeholder="Password"
                value={password}
                onChange={handleChange}
              />
              {errors.password && (
                <p className="text-danger small">{errors.password}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </CommonModal>
  );
};

PasswordSetModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  handlePasswordEntered: PropTypes.func.isRequired
};

export default PasswordSetModal;
